import React from "react";
import StyleColourPicker from "./StyleColourPicker";
import {getDefaultColour} from "./ManageColours";

const SimpleBlockStyles = props => {
    const {styles, variant, updateStylesCallback} = props;

    return (
        <>
            <h4 className="margin-t--m">Colour</h4>
            <div className="flexAlignCentre margin-t--s">
                <div className="flexMax">
                    Block background
                </div>
                <div className="flex">
                    <StyleColourPicker
                        defaultValue={getDefaultColour(`--cont-block-simple-${variant}-bg`, styles)}
                        onChange={(colour) => updateStylesCallback({
                            [`--cont-block-simple-${variant}-bg`]: colour.hex()
                        })}
                    />
                </div>
            </div>
        </>
    )
}

export default SimpleBlockStyles;